// extracted by mini-css-extract-plugin
module.exports = {"root":"DallasCard_root__DPvHG","relative":"DallasCard_relative__ihkzd","bordered":"DallasCard_bordered__SaLvh"};